export default __webpack_public_path__ + "static/media/rcs.87bd6ebf.svg";